export default Object.freeze({
  ADMIN: 0,
  MANAGER: 1,
  USER: 2,
  BILLINGUSER: 3,
});
